import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  tableData: [],
  overTime:[],
  loading: false,
}
const reducer = (state = initialState, action) => {
  switch (action.type) {

    case types.GET_WORK_TIME:

      return {
        ...state,
        loading: false,
        tableData : action.data,
        overTime:action.overTime,
      }
    case types.FAILED_WORK_TIME:

      return {
        ...state,
        loading: false,
        tableData : [],
        overTime:[]
      }
    case types.LOADER_WORK_TIME:

      return {
        ...state,
        loading: true
      }
    default:
      return state
  }
}
export default reducer